import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import * as actions from './redux/actions';
import * as pluginActions from '../plugin/redux/actions';
import { drapcodeIcon } from '../../common/custom/icon-library';
import Swal from 'sweetalert2';
import DocsLink from '../../common/custom/DocsLink';
import ParentDocCard from '../common/ParentDocCard';
import { TemplateHeaderNav } from './TemplateHeaderNav';
import {
  EMAIL_TEMPLATE,
  SMS_TEMPLATE,
  TOOLTIP_TEMPLATE,
  AGREEMENT_TEMPLATE,
  TYPESENSE_SEARCH_TEMPLATE,
  SOCKET_IO_TEMPLATE,
} from 'drapcode-constant';
import showAlert from '../../common/utils/alert';
import TooltipInfo from '../../common/docs/TooltipInfo';
import { description } from '../../common/utils/event_constants';

export class DefaultPage extends Component {
  static propTypes = {
    template: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = { activeTab: EMAIL_TEMPLATE };
  toggle = (activeTab) => {
    this.setState({ activeTab: activeTab });
  };
  componentDidMount = () => {
    const { match, location, actions, pluginActions } = this.props;
    const { projectId, version } = match.params;
    if (typeof location.state !== 'undefined' && location.state.activeTab) {
      this.setState({ activeTab: location.state.activeTab });
    }
    pluginActions.loadAllInstalledPlugin({ projectId, version });
    actions.fetchAllSmsTemplate({ projectId, version });
    actions.fetchAllMailTemplate({ projectId, version });
    actions.fetchAllTooltipTemplate({ projectId, version });
    actions.fetchAllAgreementTemplate({ projectId, version });
    actions.fetchAllTypesenseSearchTemplate({ projectId, version });
    actions.fetchAllSocketIoTemplate({ projectId, version });
    actions.getPermissionFlags({ projectId });
  };

  handleDelete = (uuid) => {
    const { projectId, version } = this.props.match.params;
    const preConfirm = () => {
      this.props.actions.deleteTemplate({ projectId: projectId, version, templateId: uuid });
    };
    showAlert("You won't be able to revert this.", preConfirm, 'Yes, delete it!');
  };

  fetchTemplateTenants = (template) => {
    const tenants = template.tenants
      ? template.tenants.map((tenant) => tenant.name).join(', ')
      : [];
    return tenants ? tenants : '';
  };

  noDataTemplate = () => {
    return (
      <tr>
        <td></td>
        <td>No Existing Templates!</td>
        <td></td>
      </tr>
    );
  };

  render() {
    const { match, template, plugin } = this.props;
    const { projectId, version } = match.params;
    const {
      mailTemplates,
      smsTemplates,
      tooltipTemplates,
      permissionFlags,
      agreementTemplates,
      typesenseSearchTemplates,
      socketIoTemplates,
    } = template;
    const { activeTab } = this.state;
    const { installedPlugins } = plugin;
    let emailFlag, tooltipFlag, smsFlag, agreementFlag, typesenseSearchFlag, socketIoSearchFlag;
    if (permissionFlags && permissionFlags.length > 0) {
      emailFlag = permissionFlags.includes(EMAIL_TEMPLATE);
      tooltipFlag = permissionFlags.includes(TOOLTIP_TEMPLATE);
      smsFlag = permissionFlags.includes(SMS_TEMPLATE);
      agreementFlag = permissionFlags.includes(AGREEMENT_TEMPLATE);
      typesenseSearchFlag = permissionFlags.includes(TYPESENSE_SEARCH_TEMPLATE);
      socketIoSearchFlag = permissionFlags.includes(SOCKET_IO_TEMPLATE);
    }

    //TODO: Can be refactor
    return (
      <div className="main">
        <div className="section">
          <div className="container templates">
            <TemplateHeaderNav
              activeTab={activeTab}
              title="Template"
              icon="template"
              toggle={this.toggle}
              installedPlugins={installedPlugins}
            />
            <div className="row mx-auto">
              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
                <div className="tab-content">
                  <div
                    className={`tab-pane ${activeTab === SMS_TEMPLATE && 'active'}`}
                    id="smsTemplate"
                  >
                    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
                      <div className="card">
                        <div
                          className="card-header card-header-icon"
                          data-background-color="drapcode-violet"
                        >
                          <i className={`wb ${drapcodeIcon(SMS_TEMPLATE)}`}></i>
                        </div>
                        <div className="card-content">
                          <div className="card-title-header">
                            <h4 className="card-title">SMS Templates</h4>
                            <div className="card-cta">
                              <Link
                                to={{
                                  pathname: `/template/${version}/v/${projectId}/messages/create`,
                                  state: { activeTab: SMS_TEMPLATE },
                                }}
                                className="btn btn-theme-submit btn-md"
                                title="Create SMS Template"
                              >
                                <i className="wb webconnect-plus" /> Create SMS Template
                              </Link>
                            </div>
                          </div>
                          <div className="table-responsive">
                            <table className="table table-bordered table-hover table-sm table-word-break">
                              <thead>
                                <tr className="text-left">
                                  <th>#</th>
                                  <th className="w-80">Name</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {smsTemplates.length > 0
                                  ? smsTemplates.map((template, index) => {
                                      return (
                                        <tr key={template.name} className="text-left">
                                          <td className="align-middle">{index + 1}</td>
                                          <td className="align-middle">{template.name}</td>
                                          <td className="align-middle text-right">
                                            <Link
                                              to={`/template/${version}/v/${projectId}/messages/${template.uuid}`}
                                              className="btn btn-xs btn-primary"
                                              title={`Edit ${template.name}`}
                                            >
                                              <i className="wb webconnect-pencil"></i>
                                            </Link>
                                            &nbsp;
                                            <button
                                              className="btn btn-xs btn-theme-delete"
                                              style={{
                                                cursor: smsFlag ? 'pointer' : 'not-allowed',
                                              }}
                                              onClick={() =>
                                                smsFlag
                                                  ? this.handleDelete(template.uuid)
                                                  : undefined
                                              }
                                              title={`Delete ${template.name}`}
                                            >
                                              <i className="wb webconnect-trash-solid"></i>&nbsp;
                                              {smsFlag ? null : (
                                                <TooltipInfo
                                                  title={description}
                                                  headerText={`Permission Disabled!`}
                                                  showHeader={true}
                                                  showArrow={true}
                                                />
                                              )}
                                            </button>
                                          </td>
                                        </tr>
                                      );
                                    })
                                  : this.noDataTemplate()}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>

                    <ParentDocCard>
                      <h5>
                        <b>SMS Template</b>
                      </h5>
                      <p>You can create custom SMS templates and send them to different users.</p>
                    </ParentDocCard>
                  </div>

                  <div
                    className={`tab-pane ${activeTab === EMAIL_TEMPLATE && 'active'}`}
                    id="emailTemplate"
                  >
                    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
                      <div className="card">
                        <div
                          className="card-header card-header-icon"
                          data-background-color="drapcode-violet"
                        >
                          <i className={`wb ${drapcodeIcon(EMAIL_TEMPLATE)}`}></i>
                        </div>
                        <div className="card-content">
                          <div className="card-title-header">
                            <h4 className="card-title">Email Templates</h4>
                            <div className="card-cta">
                              <Link
                                to={{
                                  pathname: `/template/${version}/v/${projectId}/mails/create`,
                                  state: { activeTab: EMAIL_TEMPLATE },
                                }}
                                className="btn btn-theme-submit btn-md"
                                title="Create Email Template"
                              >
                                <i className="wb webconnect-plus" /> Create Email Template
                              </Link>
                            </div>
                          </div>
                          <div className="table-responsive">
                            <table className="table table-bordered table-hover table-sm table-word-break">
                              <thead>
                                <tr className="text-left">
                                  <th>#</th>
                                  <th className="w-50">Name</th>
                                  <th>Tenant Template</th>
                                  <th>Tenants</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {mailTemplates.length > 0
                                  ? mailTemplates.map((template, index) => {
                                      return (
                                        <tr key={template.name} className="text-left">
                                          <td className="align-middle">{index + 1}</td>
                                          <td className="align-middle">{template.name}</td>
                                          <td className="align-middle">
                                            {template.parentTemplateId ? 'Yes' : 'No'}
                                          </td>
                                          <td className="align-middle">
                                            {template.parentTemplateId
                                              ? this.fetchTemplateTenants(template)
                                              : ''}
                                          </td>
                                          <td className="text-right">
                                            <Link
                                              to={`/template/${version}/v/${projectId}/mails/${template.uuid}`}
                                              className="btn btn-xs btn-primary"
                                              title={`Edit ${template.name}`}
                                            >
                                              <i className="wb webconnect-pencil"></i>
                                            </Link>
                                            &nbsp;
                                            <button
                                              className="btn btn-xs btn-theme-delete"
                                              style={{
                                                cursor: emailFlag ? 'pointer' : 'not-allowed',
                                              }}
                                              onClick={() =>
                                                emailFlag
                                                  ? this.handleDelete(template.uuid)
                                                  : undefined
                                              }
                                              title={`Delete ${template.name}`}
                                            >
                                              <i className="wb webconnect-trash-solid"></i>&nbsp;
                                              {emailFlag ? null : (
                                                <TooltipInfo
                                                  title={description}
                                                  headerText={`Permission Disabled!`}
                                                  showHeader={true}
                                                  showArrow={true}
                                                />
                                              )}
                                            </button>
                                          </td>
                                        </tr>
                                      );
                                    })
                                  : this.noDataTemplate()}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <ParentDocCard>
                      <h5>
                        <b>Email Template</b>
                      </h5>
                      <p>
                        You can create custom email templates and send them to different users. We
                        have created a step-by-step documentation that covers email template
                        creation, event configuration and execution.
                      </p>
                      <br />
                      <DocsLink link="https://academy.drapcode.com/docs/app-event/event-dynamic-email-action/" />
                    </ParentDocCard>
                  </div>

                  <div
                    className={`tab-pane ${activeTab === TOOLTIP_TEMPLATE && 'active'}`}
                    id="emailTemplate"
                  >
                    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
                      <div className="card">
                        <div
                          className="card-header card-header-icon"
                          data-background-color="drapcode-violet"
                        >
                          <i className={`wb ${drapcodeIcon(TOOLTIP_TEMPLATE)}`}></i>
                        </div>
                        <div className="card-content">
                          <div className="card-title-header">
                            <h4 className="card-title">Tooltip Templates</h4>
                            <div className="card-cta">
                              <Link
                                to={{
                                  pathname: `/template/${version}/v/${projectId}/tooltips/create`,
                                  state: { activeTab: TOOLTIP_TEMPLATE },
                                }}
                                className="btn btn-theme-submit btn-md"
                                title="Create Email Template"
                              >
                                <i className="wb webconnect-plus" /> Create Tooltip Template
                              </Link>
                            </div>
                          </div>
                          <div className="table-responsive">
                            <table className="table table-bordered table-hover table-sm table-word-break">
                              <thead>
                                <tr className="text-left">
                                  <th>#</th>
                                  <th className="w-80">Name</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {tooltipTemplates.length > 0
                                  ? tooltipTemplates.map((template, index) => {
                                      return (
                                        <tr key={template.name} className="text-left">
                                          <td className="align-middle">{index + 1}</td>
                                          <td className="align-middle">{template.name}</td>
                                          <td className="text-right">
                                            <Link
                                              to={`/template/${version}/v/${projectId}/tooltips/${template.uuid}`}
                                              className="btn btn-xs btn-primary"
                                              title={`Edit ${template.name}`}
                                            >
                                              <i className="wb webconnect-pencil"></i>
                                            </Link>
                                            &nbsp;
                                            <button
                                              className="btn btn-xs btn-theme-delete"
                                              onClick={() =>
                                                tooltipFlag
                                                  ? this.handleDelete(template.uuid)
                                                  : undefined
                                              }
                                              style={{
                                                cursor: tooltipFlag ? 'pointer' : 'not-allowed',
                                              }}
                                              title={`Delete ${template.name}`}
                                            >
                                              <i className="wb webconnect-trash-solid"></i>&nbsp;
                                              {tooltipFlag ? null : (
                                                <TooltipInfo
                                                  title={description}
                                                  headerText={`Permission Disabled!`}
                                                  showHeader={true}
                                                  showArrow={true}
                                                />
                                              )}
                                            </button>
                                          </td>
                                        </tr>
                                      );
                                    })
                                  : this.noDataTemplate()}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <ParentDocCard>
                      <h5>
                        <b>Tooltip Template</b>
                      </h5>
                      <p>You can create custom tooltip templates.</p>
                      <br />
                    </ParentDocCard>
                  </div>

                  <div
                    className={`tab-pane ${activeTab === AGREEMENT_TEMPLATE && 'active'}`}
                    id="agreementTemplate"
                  >
                    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
                      <div className="card">
                        <div
                          className="card-header card-header-icon"
                          data-background-color="drapcode-violet"
                        >
                          <i className={`wb ${drapcodeIcon(AGREEMENT_TEMPLATE)}`}></i>
                        </div>
                        <div className="card-content">
                          <div className="card-title-header">
                            <h4 className="card-title">Agreement Templates</h4>
                            <div className="card-cta">
                              <Link
                                to={{
                                  pathname: `/template/${version}/v/${projectId}/agreements/create`,
                                  state: { activeTab: AGREEMENT_TEMPLATE },
                                }}
                                className="btn btn-theme-submit btn-md"
                                title="Create Agreement Template"
                              >
                                <i className="wb webconnect-plus" /> Create Agreement Template
                              </Link>
                            </div>
                          </div>
                          <div className="table-responsive">
                            <table className="table table-bordered table-hover table-sm table-word-break">
                              <thead>
                                <tr className="text-left">
                                  <th>#</th>
                                  <th className="w-80">Name</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {agreementTemplates.length > 0
                                  ? agreementTemplates.map((template, index) => {
                                      return (
                                        <tr key={template.name} className="text-left">
                                          <td className="align-middle">{index + 1}</td>
                                          <td className="align-middle">{template.name}</td>
                                          <td className="text-right">
                                            <Link
                                              to={`/template/${version}/v/${projectId}/agreements/${template.uuid}`}
                                              className="btn btn-xs btn-primary"
                                              title={`Edit ${template.name}`}
                                            >
                                              <i className="wb webconnect-pencil"></i>
                                            </Link>
                                            &nbsp;
                                            <button
                                              className="btn btn-xs btn-theme-delete"
                                              style={{
                                                cursor: agreementFlag ? 'pointer' : 'not-allowed',
                                              }}
                                              onClick={() =>
                                                agreementFlag
                                                  ? this.handleDelete(template.uuid)
                                                  : undefined
                                              }
                                              title={`Delete ${template.name}`}
                                            >
                                              <i className="wb webconnect-trash-solid"></i>&nbsp;
                                              {agreementFlag ? null : (
                                                <TooltipInfo
                                                  title={description}
                                                  headerText={`Permission Disabled!`}
                                                  showHeader={true}
                                                  showArrow={true}
                                                />
                                              )}
                                            </button>
                                          </td>
                                        </tr>
                                      );
                                    })
                                  : this.noDataTemplate()}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <ParentDocCard>
                      <h5>
                        <b>Agreement Template</b>
                      </h5>
                      <p>You can create custom agreement templates.</p>
                      <br />
                    </ParentDocCard>
                  </div>
                  <div
                    className={`tab-pane ${activeTab === TYPESENSE_SEARCH_TEMPLATE && 'active'}`}
                    id="typesenseSearchTemplate"
                  >
                    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
                      <div className="card">
                        <div
                          className="card-header card-header-icon"
                          data-background-color="drapcode-violet"
                        >
                          <i className={`wb ${drapcodeIcon(TYPESENSE_SEARCH_TEMPLATE)}`}></i>
                        </div>
                        <div className="card-content">
                          <div className="card-title-header">
                            <h4 className="card-title">Typesense Search Templates</h4>
                            <div className="card-cta">
                              <Link
                                to={{
                                  pathname: `/template/${version}/v/${projectId}/typesenseSearch/create`,
                                  state: { activeTab: TYPESENSE_SEARCH_TEMPLATE },
                                }}
                                className="btn btn-theme-submit btn-md"
                                title="Create Typesense Search Template"
                              >
                                <i className="wb webconnect-plus" /> Create Typesense Search
                                Template
                              </Link>
                            </div>
                          </div>
                          <div className="table-responsive">
                            <table className="table table-bordered table-hover table-sm table-word-break">
                              <thead>
                                <tr className="text-left">
                                  <th>#</th>
                                  <th className="w-80">Name</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {typesenseSearchTemplates.length > 0
                                  ? typesenseSearchTemplates.map((template, index) => {
                                      return (
                                        <tr key={template.name} className="text-left">
                                          <td className="align-middle">{index + 1}</td>
                                          <td className="align-middle">{template.name}</td>
                                          <td className="text-right">
                                            <Link
                                              to={`/template/${version}/v/${projectId}/typesenseSearch/${template.uuid}`}
                                              className="btn btn-xs btn-primary"
                                              title={`Edit ${template.name}`}
                                            >
                                              <i className="wb webconnect-pencil"></i>
                                            </Link>
                                            &nbsp;
                                            <button
                                              className="btn btn-xs btn-theme-delete"
                                              style={{
                                                cursor: typesenseSearchFlag
                                                  ? 'pointer'
                                                  : 'not-allowed',
                                              }}
                                              onClick={() =>
                                                typesenseSearchFlag
                                                  ? this.handleDelete(template.uuid)
                                                  : undefined
                                              }
                                              title={`Delete ${template.name}`}
                                            >
                                              <i className="wb webconnect-trash-solid"></i>&nbsp;
                                              {typesenseSearchFlag ? null : (
                                                <TooltipInfo
                                                  title={description}
                                                  headerText={`Permission Disabled!`}
                                                  showHeader={true}
                                                  showArrow={true}
                                                />
                                              )}
                                            </button>
                                          </td>
                                        </tr>
                                      );
                                    })
                                  : this.noDataTemplate()}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <ParentDocCard>
                      <h5>
                        <b>Typesense Search Template</b>
                      </h5>
                      <p>You can create custom typesense search templates.</p>
                      <br />
                    </ParentDocCard>
                  </div>
                  <div
                    className={`tab-pane ${activeTab === SOCKET_IO_TEMPLATE && 'active'}`}
                    id="socketIOTemplate"
                  >
                    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
                      <div className="card">
                        <div
                          className="card-header card-header-icon"
                          data-background-color="drapcode-violet"
                        >
                          <i className={`wb ${drapcodeIcon(SOCKET_IO_TEMPLATE)}`}></i>
                        </div>
                        <div className="card-content">
                          <div className="card-title-header">
                            <h4 className="card-title">Socket IO Templates</h4>
                            <div className="card-cta">
                              <Link
                                to={{
                                  pathname: `/template/${version}/v/${projectId}/socketIo/create`,
                                  state: { activeTab: SOCKET_IO_TEMPLATE },
                                }}
                                className="btn btn-theme-submit btn-md"
                                title="Create Socket IO Template"
                              >
                                <i className="wb webconnect-plus" /> Create Socket IO Template
                              </Link>
                            </div>
                          </div>
                          <div className="table-responsive">
                            <table className="table table-bordered table-hover table-sm table-word-break">
                              <thead>
                                <tr className="text-left">
                                  <th>#</th>
                                  <th className="w-80">Name</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {socketIoTemplates.length > 0
                                  ? socketIoTemplates.map((template, index) => {
                                      return (
                                        <tr key={template.name} className="text-left">
                                          <td className="align-middle">{index + 1}</td>
                                          <td className="align-middle">{template.name}</td>
                                          <td className="text-right">
                                            <Link
                                              to={`/template/${version}/v/${projectId}/socketIo/${template.uuid}`}
                                              className="btn btn-xs btn-primary"
                                              title={`Edit ${template.name}`}
                                            >
                                              <i className="wb webconnect-pencil"></i>
                                            </Link>
                                            &nbsp;
                                            <button
                                              className="btn btn-xs btn-theme-delete"
                                              style={{
                                                cursor: socketIoSearchFlag
                                                  ? 'pointer'
                                                  : 'not-allowed',
                                              }}
                                              onClick={() =>
                                                socketIoSearchFlag
                                                  ? this.handleDelete(template.uuid)
                                                  : undefined
                                              }
                                              title={`Delete ${template.name}`}
                                            >
                                              <i className="wb webconnect-trash-solid"></i>&nbsp;
                                              {socketIoSearchFlag ? null : (
                                                <TooltipInfo
                                                  title={description}
                                                  headerText={`Permission Disabled!`}
                                                  showHeader={true}
                                                  showArrow={true}
                                                />
                                              )}
                                            </button>
                                          </td>
                                        </tr>
                                      );
                                    })
                                  : this.noDataTemplate()}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <ParentDocCard>
                      <h5>
                        <b>Socket IO Template</b>
                      </h5>
                      <p>You can create custom socket IO templates.</p>
                      <br />
                    </ParentDocCard>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    template: state.template,
    plugin: state.plugin,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    pluginActions: bindActionCreators({ ...pluginActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultPage);
